import React from 'react';

import { UsersTable } from '../organisms/UsersTable/UsersTable';

const UserListPage = () => {
  return <UsersTable />;
};

export default UserListPage;
